
import React from 'react'
import { Row, Col, Button, Space, Typography, Flex } from 'antd'
import { LeftOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

const { Text, Title } = Typography

function PageHeader({
  onBack = null,
  subTitle = '',
  title = '',
  footer = null,
  children = null,
  extra = null,
  fullExtraWidth = false,
}) {
  const theme = useTheme()
  return (
    <div className="page-heading my-2">
      <Row align="top" className="mb-1">
        <Col>
          <Space align="start">
            {onBack && (
              <Button
                onClick={onBack}
                icon={<LeftOutlined className="anticon" />}
              />
            )}
            <Flex gap="middle" align="center" justify="flex-end">
              <Title className="title" level={3} >
                {title}
              </Title>
              {subTitle && <Text type="secondary">{subTitle}</Text>}
              {footer}
            </Flex>
          </Space>
        </Col>
        <Col
          flex="auto"
          style={{
            textAlign: 'right',
            width: fullExtraWidth ? '100%' : 'auto',
          }}
        >
          <Space style={{ width: fullExtraWidth ? '100%' : 'auto' }}>
            {extra}
          </Space>
        </Col>
      </Row>
      <Row>
        {React.Children.map(children, child => (
          <span className="page-actions_meta">{child}</span>
        ))}
      </Row>
      <style>{`
        .page-heading {
          padding: 16px 24px;
          margin-bottom: 23px;
          border: solid 1px ${theme.lightGray};
        }
        .page-heading .title {
          color: ${theme.brandPrimary};
          margin-top: 0;
          margin-bottom: 0;
        }
        .page-actions_meta {
          width: 100%;
        }
        .title {
          flex: 1;
          white-space: nowrap;
        }
      `}</style>
    </div>
  )
}

export default PageHeader

PageHeader.propTypes = {
  onBack: PropTypes.func,
  subTitle: PropTypes.string,
  title: PropTypes.string,
  footer: PropTypes.node,
  children: PropTypes.node,
  extra: PropTypes.node,
  fullExtraWidth: PropTypes.bool,
}
